import { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import { blogPosts } from '../../mocks/blog';

const BlogDetailPage = () => {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);
  const relatedPosts = post ? blogPosts.filter((p) => p.id !== post.id).slice(0, 3) : [];

  useEffect(() => {
    if (!post) return;

    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://esbilgisayar.com.tr';

    document.title = `${post.title} | Es Donanım Bilgisayar Blog`;

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', post.excerpt);
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', `${post.category}, bilgisayar blog, ${post.title}`);
    }

    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', `${siteUrl}/blog/${post.slug}`);

    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      "headline": post.title,
      "description": post.excerpt,
      "image": post.image,
      "datePublished": post.date,
      "dateModified": post.date,
      "author": {
        "@type": "Organization",
        "name": "Es Donanım Bilgisayar",
        "url": siteUrl
      },
      "publisher": {
        "@type": "Organization",
        "name": "Es Donanım Bilgisayar"
      },
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": `${siteUrl}/blog/${post.slug}`
      },
      "articleSection": post.category,
      "keywords": `${post.category}, bilgisayar, teknoloji`
    });
    document.head.appendChild(schemaScript);

    return () => {
      if (document.head.contains(schemaScript)) {
        document.head.removeChild(schemaScript);
      }
    };
  }, [post]);

  if (!post) {
    return (
      <div className="min-h-screen bg-white">
        <Navbar />
        <main className="pb-16 lg:pb-0 pt-32">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center py-24">
            <i className="ri-file-unknow-line text-6xl text-neutral-300 mb-6 block"></i>
            <h1 className="text-3xl font-bold text-primary mb-4">Yazı Bulunamadı</h1>
            <p className="text-neutral-600 mb-8">Aradığınız blog yazısı mevcut değil veya kaldırılmış olabilir.</p>
            <Link
              to="/blog"
              className="inline-flex items-center space-x-2 bg-secondary text-white px-6 py-3 rounded-lg font-semibold hover:bg-secondary/90 transition-colors"
            >
              <i className="ri-arrow-left-line"></i>
              <span>Blog'a Dön</span>
            </Link>
          </div>
        </main>
        <Footer />
        <WhatsAppButton />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pb-16 lg:pb-0">
        {/* Hero Section */}
        <section className="pt-32 pb-12 bg-neutral-50">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <Link
              to="/blog"
              className="inline-flex items-center space-x-2 text-secondary font-semibold mb-8 hover:underline transition-all cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              <span>Blog'a Dön</span>
            </Link>

            <div className="mb-6">
              <span className="px-3 py-1 bg-secondary text-white rounded-full text-sm font-semibold">
                {post.category}
              </span>
            </div>

            <h1 className="text-4xl lg:text-5xl font-bold text-primary mb-6 leading-tight">
              {post.title}
            </h1>

            <div className="flex flex-wrap items-center gap-6 text-neutral-600">
              <div className="flex items-center space-x-2">
                <i className="ri-calendar-line"></i>
                <span>{post.date}</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-time-line"></i>
                <span>{post.readTime} okuma</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-user-line"></i>
                <span>{post.author}</span>
              </div>
            </div>
          </div>
        </section>

        {/* Featured Image */}
        <section className="pb-12 bg-neutral-50">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <div className="relative h-96 rounded-2xl overflow-hidden shadow-lg">
              <img
                src={post.image}
                alt={post.title}
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-12 bg-white">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <article>
              <p className="text-xl text-neutral-700 leading-relaxed mb-8">
                {post.excerpt}
              </p>

              <h2 className="text-3xl font-bold text-primary mb-4 mt-12">Giriş</h2>
              <p className="text-neutral-700 leading-relaxed mb-6">
                2. el bilgisayar alım satım ve bilgisayar tamiri konularında doğru bilgiye sahip olmak, hem bütçenizi korur hem de uzun vadede daha iyi kararlar almanızı sağlar. Bu yazımızda {post.title.toLowerCase()} konusunu detaylı şekilde ele alacağız.
              </p>

              <h2 className="text-3xl font-bold text-primary mb-4 mt-12">Önemli Noktalar</h2>
              <p className="text-neutral-700 leading-relaxed mb-6">
                İkinci el bilgisayar, laptop tamiri ve masaüstü bilgisayar tamiri süreçlerinde dikkat edilmesi gereken birçok önemli nokta bulunmaktadır. Notebook tamiri, format atma, anakart tamiri ve ekran değişimi gibi işlemlerde profesyonel destek almak her zaman en doğru tercihtir.
              </p>

              <ul className="space-y-3 mb-8">
                {[
                  'Uygun fiyatlı ikinci el bilgisayar seçeneklerini araştırın',
                  'Bilgisayar bakım ve onarım için güvenilir servis seçin',
                  'Oyuncu bilgisayarı tamiri için uzman ekip tercih edin',
                  'Kurumsal bilgisayar servisi için özel paketleri değerlendirin',
                ].map((item) => (
                  <li key={item} className="flex items-start space-x-3">
                    <i className="ri-check-line text-secondary text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-neutral-700">{item}</span>
                  </li>
                ))}
              </ul>

              <h2 className="text-3xl font-bold text-primary mb-4 mt-12">Sonuç</h2>
              <p className="text-neutral-700 leading-relaxed mb-6">
                2. el bilgisayar alışı, bilgisayar tamiri ve teknik servis hizmetlerinde doğru tercihler yapmak, hem maliyetlerinizi düşürür hem de cihazlarınızın ömrünü uzatır. Es Donanım Bilgisayar olarak tüm bu konularda profesyonel destek sunuyoruz.
              </p>

              <div className="bg-blue-50 border-l-4 border-secondary p-6 rounded-lg mt-8">
                <p className="text-primary font-semibold">
                  <strong>Not:</strong> 2. el laptop, bilgisayar tamiri ve teknik servis ihtiyaçlarınız için Es Donanım Bilgisayar&apos;ı tercih edebilirsiniz. Garantili hizmet ve uygun fiyat avantajlarından yararlanın.
                </p>
              </div>
            </article>

            {/* Share Buttons */}
            <div className="flex items-center space-x-4 mt-12 pt-8 border-t border-neutral-200">
              <span className="text-neutral-600 font-semibold">Paylaş:</span>
              {[
                { icon: 'ri-facebook-fill', label: 'Facebook' },
                { icon: 'ri-twitter-x-line', label: 'Twitter' },
                { icon: 'ri-linkedin-fill', label: 'LinkedIn' },
                { icon: 'ri-whatsapp-line', label: 'WhatsApp' },
              ].map(({ icon, label }) => (
                <button
                  key={label}
                  aria-label={label}
                  className="w-10 h-10 flex items-center justify-center bg-neutral-100 hover:bg-secondary hover:text-white rounded-lg transition-colors cursor-pointer"
                >
                  <i className={icon}></i>
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Related Posts */}
        {relatedPosts.length > 0 && (
          <section className="py-24 bg-neutral-50">
            <div className="max-w-5xl mx-auto px-6 lg:px-8">
              <h2 className="text-3xl font-bold text-primary mb-12 text-center">İlgili Yazılar</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {relatedPosts.map((relatedPost) => (
                  <Link
                    key={relatedPost.id}
                    to={`/blog/${relatedPost.slug}`}
                    className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
                  >
                    <div className="relative h-48 overflow-hidden bg-neutral-100">
                      <img
                        src={relatedPost.image}
                        alt={relatedPost.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute top-4 left-4">
                        <span className="px-3 py-1 bg-secondary text-white rounded-full text-xs font-semibold">
                          {relatedPost.category}
                        </span>
                      </div>
                    </div>
                    <div className="p-6">
                      <h3 className="text-lg font-bold text-primary mb-2 line-clamp-2 group-hover:text-secondary transition-colors">
                        {relatedPost.title}
                      </h3>
                      <p className="text-neutral-600 text-sm line-clamp-2">{relatedPost.excerpt}</p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default BlogDetailPage;
